export const TOAST_NOTIFICATIONS_DATA_AUTO_TEST_IDS = {
    TOAST_COMPONENT: 'TOAST_COMPONENT',
};
